// Generated from /Users/niket/Developer/0.0.TestProjects/4.0.Antlr/FiltersV1/src/Filters.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = require('antlr4/index');

var serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  '\u0002&\u00dd\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004',
  '\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t',
  '\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004',
  '\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010',
  '\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013',
  '\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017',
  '\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a',
  '\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e',
  '\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004"\t"\u0004#',
  "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004'\t'\u0004(\t(\u0004)\t)\u0004",
  '*\t*\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0005\u0003',
  '\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003',
  '\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\b\u0003',
  '\b\u0003\b\u0003\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003\n\u0003\n\u0003',
  '\u000b\u0003\u000b\u0003\f\u0003\f\u0003\r\u0003\r\u0003\r\u0003\r\u0003',
  '\r\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003',
  '\u000e\u0003\u000f\u0003\u000f\u0003\u000f\u0007\u000f\u0088\n\u000f',
  '\f\u000f\u000e\u000f\u008b\u000b\u000f\u0003\u000f\u0003\u000f\u0003',
  '\u000f\u0003\u000f\u0007\u000f\u0091\n\u000f\f\u000f\u000e\u000f\u0094',
  '\u000b\u000f\u0003\u000f\u0005\u000f\u0097\n\u000f\u0003\u0010\u0003',
  '\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0012\u0003',
  '\u0012\u0003\u0012\u0005\u0012\u00a2\n\u0012\u0003\u0013\u0003\u0013',
  '\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0014\u0003\u0014',
  '\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017',
  '\u0003\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a',
  '\u0003\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d',
  '\u0003\u001e\u0003\u001e\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003',
  '!\u0003!\u0003"\u0003"\u0003#\u0003#\u0003$\u0003$\u0003%\u0005%\u00cd',
  "\n%\u0003&\u0003&\u0003'\u0003'\u0003(\u0003(\u0003)\u0003)\u0003",
  '*\u0006*\u00d8\n*\r*\u000e*\u00d9\u0003*\u0003*\u0002\u0002+\u0003\u0003',
  '\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f\t\u0011\n\u0013',
  '\u000b\u0015\f\u0017\r\u0019\u000e\u001b\u000f\u001d\u0010\u001f\u0002',
  "!\u0002#\u0002%\u0002'\u0002)\u0011+\u0012-\u0013/\u00141\u00153\u0016",
  '5\u00177\u00189\u0019;\u001a=\u001b?\u001cA\u001dC\u001eE\u001fG I!',
  'K"M#O$Q%S&\u0003\u0002\b\u0004\u0002$$^^\u0004\u0002))^^\n\u0002$$',
  '11^^ddhhppttvv\u0005\u00022;CHch\u0006\u0002//C\\aac|\u0005\u0002\u000b',
  '\f\u000f\u000f""\u0002\u00de\u0002\u0003\u0003\u0002\u0002\u0002\u0002',
  '\u0005\u0003\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002',
  '\t\u0003\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002',
  '\r\u0003\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002',
  '\u0011\u0003\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002',
  '\u0015\u0003\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002',
  '\u0019\u0003\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002',
  '\u001d\u0003\u0002\u0002\u0002\u0002)\u0003\u0002\u0002\u0002\u0002',
  '+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002\u0002\u0002/\u0003',
  '\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002\u00023\u0003\u0002',
  '\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u00027\u0003\u0002\u0002',
  '\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003\u0002\u0002\u0002',
  '\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002\u0002\u0002\u0002',
  'A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002\u0002\u0002E\u0003',
  '\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002\u0002I\u0003\u0002',
  '\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002M\u0003\u0002\u0002',
  '\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003\u0002\u0002\u0002',
  '\u0002S\u0003\u0002\u0002\u0002\u0003U\u0003\u0002\u0002\u0002\u0005',
  'X\u0003\u0002\u0002\u0002\u0007\\\u0003\u0002\u0002\u0002\t_\u0003\u0002',
  '\u0002\u0002\u000bd\u0003\u0002\u0002\u0002\rh\u0003\u0002\u0002\u0002',
  '\u000fk\u0003\u0002\u0002\u0002\u0011p\u0003\u0002\u0002\u0002\u0013',
  's\u0003\u0002\u0002\u0002\u0015u\u0003\u0002\u0002\u0002\u0017w\u0003',
  '\u0002\u0002\u0002\u0019y\u0003\u0002\u0002\u0002\u001b~\u0003\u0002',
  '\u0002\u0002\u001d\u0096\u0003\u0002\u0002\u0002\u001f\u0098\u0003\u0002',
  '\u0002\u0002!\u009b\u0003\u0002\u0002\u0002#\u009e\u0003\u0002\u0002',
  "\u0002%\u00a3\u0003\u0002\u0002\u0002'\u00a9\u0003\u0002\u0002\u0002",
  ')\u00ab\u0003\u0002\u0002\u0002+\u00ad\u0003\u0002\u0002\u0002-\u00af',
  '\u0003\u0002\u0002\u0002/\u00b1\u0003\u0002\u0002\u00021\u00b3\u0003',
  '\u0002\u0002\u00023\u00b5\u0003\u0002\u0002\u00025\u00b7\u0003\u0002',
  '\u0002\u00027\u00b9\u0003\u0002\u0002\u00029\u00bb\u0003\u0002\u0002',
  '\u0002;\u00bd\u0003\u0002\u0002\u0002=\u00bf\u0003\u0002\u0002\u0002',
  '?\u00c1\u0003\u0002\u0002\u0002A\u00c3\u0003\u0002\u0002\u0002C\u00c5',
  '\u0003\u0002\u0002\u0002E\u00c7\u0003\u0002\u0002\u0002G\u00c9\u0003',
  '\u0002\u0002\u0002I\u00cc\u0003\u0002\u0002\u0002K\u00ce\u0003\u0002',
  '\u0002\u0002M\u00d0\u0003\u0002\u0002\u0002O\u00d2\u0003\u0002\u0002',
  '\u0002Q\u00d4\u0003\u0002\u0002\u0002S\u00d7\u0003\u0002\u0002\u0002',
  'UV\u0007A\u0002\u0002VW\u0007*\u0002\u0002W\u0004\u0003\u0002\u0002',
  '\u0002XY\u00070\u0002\u0002YZ\u0007,\u0002\u0002Z[\u00071\u0002\u0002',
  '[\u0006\u0003\u0002\u0002\u0002\\]\u00070\u0002\u0002]^\u0007,\u0002',
  '\u0002^\b\u0003\u0002\u0002\u0002_`\u0007*\u0002\u0002`a\u0007A\u0002',
  '\u0002ab\u0007k\u0002\u0002bc\u0007+\u0002\u0002c\n\u0003\u0002\u0002',
  '\u0002de\u0007p\u0002\u0002ef\u0007k\u0002\u0002fg\u0007p\u0002\u0002',
  'g\f\u0003\u0002\u0002\u0002hi\u0007k\u0002\u0002ij\u0007p\u0002\u0002',
  'j\u000e\u0003\u0002\u0002\u0002kl\u0007p\u0002\u0002lm\u0007w\u0002',
  '\u0002mn\u0007n\u0002\u0002no\u0007n\u0002\u0002o\u0010\u0003\u0002',
  '\u0002\u0002pq\u0007&\u0002\u0002qr\u00070\u0002\u0002r\u0012\u0003',
  '\u0002\u0002\u0002st\u0007B\u0002\u0002t\u0014\u0003\u0002\u0002\u0002',
  "uv\u0007'\u0002\u0002v\u0016\u0003\u0002\u0002\u0002wx\u0007A\u0002",
  '\u0002x\u0018\u0003\u0002\u0002\u0002yz\u0007v\u0002\u0002z{\u0007t',
  '\u0002\u0002{|\u0007w\u0002\u0002|}\u0007g\u0002\u0002}\u001a\u0003',
  '\u0002\u0002\u0002~\u007f\u0007h\u0002\u0002\u007f\u0080\u0007c\u0002',
  '\u0002\u0080\u0081\u0007n\u0002\u0002\u0081\u0082\u0007u\u0002\u0002',
  '\u0082\u0083\u0007g\u0002\u0002\u0083\u001c\u0003\u0002\u0002\u0002',
  '\u0084\u0089\u0007$\u0002\u0002\u0085\u0088\u0005#\u0012\u0002\u0086',
  '\u0088\n\u0002\u0002\u0002\u0087\u0085\u0003\u0002\u0002\u0002\u0087',
  '\u0086\u0003\u0002\u0002\u0002\u0088\u008b\u0003\u0002\u0002\u0002\u0089',
  '\u0087\u0003\u0002\u0002\u0002\u0089\u008a\u0003\u0002\u0002\u0002\u008a',
  '\u008c\u0003\u0002\u0002\u0002\u008b\u0089\u0003\u0002\u0002\u0002\u008c',
  '\u0097\u0007$\u0002\u0002\u008d\u0092\u0007)\u0002\u0002\u008e\u0091',
  '\u0005#\u0012\u0002\u008f\u0091\n\u0003\u0002\u0002\u0090\u008e\u0003',
  '\u0002\u0002\u0002\u0090\u008f\u0003\u0002\u0002\u0002\u0091\u0094\u0003',
  '\u0002\u0002\u0002\u0092\u0090\u0003\u0002\u0002\u0002\u0092\u0093\u0003',
  '\u0002\u0002\u0002\u0093\u0095\u0003\u0002\u0002\u0002\u0094\u0092\u0003',
  '\u0002\u0002\u0002\u0095\u0097\u0007)\u0002\u0002\u0096\u0084\u0003',
  '\u0002\u0002\u0002\u0096\u008d\u0003\u0002\u0002\u0002\u0097\u001e\u0003',
  '\u0002\u0002\u0002\u0098\u0099\u0005Q)\u0002\u0099\u009a\u0005Q)\u0002',
  '\u009a \u0003\u0002\u0002\u0002\u009b\u009c\u0005O(\u0002\u009c\u009d',
  '\u0005O(\u0002\u009d"\u0003\u0002\u0002\u0002\u009e\u00a1\u0007^\u0002',
  '\u0002\u009f\u00a2\t\u0004\u0002\u0002\u00a0\u00a2\u0005%\u0013\u0002',
  '\u00a1\u009f\u0003\u0002\u0002\u0002\u00a1\u00a0\u0003\u0002\u0002\u0002',
  '\u00a2$\u0003\u0002\u0002\u0002\u00a3\u00a4\u0007w\u0002\u0002\u00a4',
  "\u00a5\u0005'\u0014\u0002\u00a5\u00a6\u0005'\u0014\u0002\u00a6\u00a7",
  "\u0005'\u0014\u0002\u00a7\u00a8\u0005'\u0014\u0002\u00a8&\u0003\u0002",
  '\u0002\u0002\u00a9\u00aa\t\u0005\u0002\u0002\u00aa(\u0003\u0002\u0002',
  '\u0002\u00ab\u00ac\u0007*\u0002\u0002\u00ac*\u0003\u0002\u0002\u0002',
  '\u00ad\u00ae\u0007+\u0002\u0002\u00ae,\u0003\u0002\u0002\u0002\u00af',
  '\u00b0\u0007]\u0002\u0002\u00b0.\u0003\u0002\u0002\u0002\u00b1\u00b2',
  '\u0007_\u0002\u0002\u00b20\u0003\u0002\u0002\u0002\u00b3\u00b4\u0007',
  '-\u0002\u0002\u00b42\u0003\u0002\u0002\u0002\u00b5\u00b6\u0007/\u0002',
  '\u0002\u00b64\u0003\u0002\u0002\u0002\u00b7\u00b8\u0007,\u0002\u0002',
  '\u00b86\u0003\u0002\u0002\u0002\u00b9\u00ba\u00071\u0002\u0002\u00ba',
  '8\u0003\u0002\u0002\u0002\u00bb\u00bc\u0007@\u0002\u0002\u00bc:\u0003',
  '\u0002\u0002\u0002\u00bd\u00be\u0007>\u0002\u0002\u00be<\u0003\u0002',
  '\u0002\u0002\u00bf\u00c0\u0007#\u0002\u0002\u00c0>\u0003\u0002\u0002',
  '\u0002\u00c1\u00c2\u0007?\u0002\u0002\u00c2@\u0003\u0002\u0002\u0002',
  '\u00c3\u00c4\u0007\u0080\u0002\u0002\u00c4B\u0003\u0002\u0002\u0002',
  '\u00c5\u00c6\u0007A\u0002\u0002\u00c6D\u0003\u0002\u0002\u0002\u00c7',
  '\u00c8\u00070\u0002\u0002\u00c8F\u0003\u0002\u0002\u0002\u00c9\u00ca',
  '\u0007`\u0002\u0002\u00caH\u0003\u0002\u0002\u0002\u00cb\u00cd\t\u0006',
  '\u0002\u0002\u00cc\u00cb\u0003\u0002\u0002\u0002\u00cdJ\u0003\u0002',
  '\u0002\u0002\u00ce\u00cf\u00042;\u0002\u00cfL\u0003\u0002\u0002\u0002',
  '\u00d0\u00d1\u0007.\u0002\u0002\u00d1N\u0003\u0002\u0002\u0002\u00d2',
  '\u00d3\u0007~\u0002\u0002\u00d3P\u0003\u0002\u0002\u0002\u00d4\u00d5',
  '\u0007(\u0002\u0002\u00d5R\u0003\u0002\u0002\u0002\u00d6\u00d8\t\u0007',
  '\u0002\u0002\u00d7\u00d6\u0003\u0002\u0002\u0002\u00d8\u00d9\u0003\u0002',
  '\u0002\u0002\u00d9\u00d7\u0003\u0002\u0002\u0002\u00d9\u00da\u0003\u0002',
  '\u0002\u0002\u00da\u00db\u0003\u0002\u0002\u0002\u00db\u00dc\b*\u0002',
  '\u0002\u00dcT\u0003\u0002\u0002\u0002\u000b\u0002\u0087\u0089\u0090',
  '\u0092\u0096\u00a1\u00cc\u00d9\u0003\u0002\u0003\u0002',
].join('');

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

function FiltersLexer(input) {
  antlr4.Lexer.call(this, input);
  this._interp = new antlr4.atn.LexerATNSimulator(
    this,
    atn,
    decisionsToDFA,
    new antlr4.PredictionContextCache(),
  );
  return this;
}

FiltersLexer.prototype = Object.create(antlr4.Lexer.prototype);
FiltersLexer.prototype.constructor = FiltersLexer;

FiltersLexer.EOF = antlr4.Token.EOF;
FiltersLexer.T__0 = 1;
FiltersLexer.T__1 = 2;
FiltersLexer.T__2 = 3;
FiltersLexer.T__3 = 4;
FiltersLexer.T__4 = 5;
FiltersLexer.T__5 = 6;
FiltersLexer.T__6 = 7;
FiltersLexer.PATHTOKEN = 8;
FiltersLexer.ATNAME = 9;
FiltersLexer.PNAME = 10;
FiltersLexer.ENAME = 11;
FiltersLexer.TRUE = 12;
FiltersLexer.FALSE = 13;
FiltersLexer.STRING = 14;
FiltersLexer.LPAREN = 15;
FiltersLexer.RPAREN = 16;
FiltersLexer.LBRACKET = 17;
FiltersLexer.RBRACKET = 18;
FiltersLexer.PLUS = 19;
FiltersLexer.MINUS = 20;
FiltersLexer.TIMES = 21;
FiltersLexer.DIV = 22;
FiltersLexer.GT = 23;
FiltersLexer.LT = 24;
FiltersLexer.NOT = 25;
FiltersLexer.EQ = 26;
FiltersLexer.TILDE = 27;
FiltersLexer.QM = 28;
FiltersLexer.POINT = 29;
FiltersLexer.CARET = 30;
FiltersLexer.LETTER = 31;
FiltersLexer.DIGIT = 32;
FiltersLexer.COMMA = 33;
FiltersLexer.PIPE = 34;
FiltersLexer.AMP = 35;
FiltersLexer.WS = 36;

FiltersLexer.prototype.channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];

FiltersLexer.prototype.modeNames = ['DEFAULT_MODE'];

FiltersLexer.prototype.literalNames = [
  null,
  "'?('",
  "'.*/'",
  "'.*'",
  "'(?i)'",
  "'nin'",
  "'in'",
  "'null'",
  "'$.'",
  "'@'",
  "'%'",
  null,
  "'true'",
  "'false'",
  null,
  "'('",
  "')'",
  "'['",
  "']'",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'>'",
  "'<'",
  "'!'",
  "'='",
  "'~'",
  null,
  "'.'",
  "'^'",
  null,
  null,
  "','",
  "'|'",
  "'&'",
];

FiltersLexer.prototype.symbolicNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'PATHTOKEN',
  'ATNAME',
  'PNAME',
  'ENAME',
  'TRUE',
  'FALSE',
  'STRING',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'NOT',
  'EQ',
  'TILDE',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'PIPE',
  'AMP',
  'WS',
];

FiltersLexer.prototype.ruleNames = [
  'T__0',
  'T__1',
  'T__2',
  'T__3',
  'T__4',
  'T__5',
  'T__6',
  'PATHTOKEN',
  'ATNAME',
  'PNAME',
  'ENAME',
  'TRUE',
  'FALSE',
  'STRING',
  'FILTER_AND',
  'FILTER_OR',
  'ESC',
  'UNICODE',
  'HEX',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'NOT',
  'EQ',
  'TILDE',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'PIPE',
  'AMP',
  'WS',
];

FiltersLexer.prototype.grammarFileName = 'Filters.g4';

exports.FiltersLexer = FiltersLexer;
